export default {
      id: "ic_info_grey-usage",
      viewBox: "0 0 14 14",
      url: "/" + "images/icons.3.109.2.svg#ic_info_grey-usage",
      toString: function () {
        return this.url;
      }
    }